// DOM
let $loader;

let isTouchDevice;

function init() {
	isTouchDevice = Modernizr.touchevents;

	pageLoadDelayer();
}

function addLoader($container) {
	$loader = $(
		'<div class="c-svg-loader__overlay fade-in js-fullLoader"><div class="c-svg-loader__spinner"><img src="/_ui/responsive/common/images/loader/loading.gif "></div></div>'
	);
	$container.append($loader);
}

function removeLoader() {
	if ($(".js-fullLoader").length) {
		$(".js-fullLoader").remove();
	}
}

function pageLoadDelayer() {
	$(".js-page-load-delayer").swipe({
		longTap(event) {
			if (isTouchDevice) {
				event.preventDefault();
				const _link = $(this).attr("href");
				if (_link === undefined) {
					return;
				}
				addLoader($("body"));
				setTimeout(() => {
					window.location.href = _link;
				}, 2000);
			}
		},
		longTapThreshold: 50,
	});
}

export { init, addLoader, removeLoader };
